import { render } from "./ResetPasswordModal.vue?vue&type=template&id=c3b79656&scoped=true&ts=true&lang=pug"
import script from "./ResetPasswordModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPasswordModal.vue?vue&type=script&setup=true&lang=ts"

import "./ResetPasswordModal.vue?vue&type=style&index=0&id=c3b79656&lang=scss"
import "./ResetPasswordModal.vue?vue&type=style&index=1&id=c3b79656&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b79656"]])

export default __exports__